import { useLocSettings } from "../../hooks/SettingsHooks";
import ProductsFiltersItem from "./ProductsFiltersItem";
import {
  useBjelinTranslations,
  useSpecsTranslation
} from "../../hooks/TranslationHooks";
import { Collapse } from "reactstrap";
import Icon from "../Icon";
import { useState } from "react";
import classNames from "classnames";
import { AnimatePresence, motion } from "motion/react";
import "./style.scss";

const FILTER_VALUE_CHAR_SPACE = 40;

const ProductsFilter = ({ filterField, data, activeFilters, setFilter }) => {
  const settings = useLocSettings();
  const t = useBjelinTranslations();
  const ts = useSpecsTranslation();
  const [expanded, setExpanded] = useState(!!activeFilters[filterField]);
  let charCount = ts(filterField).length + 1;
  let moreCount = 0;

  return (
    <div
      key={filterField}
      className={classNames("filter", { "filter-expanded": expanded })}
    >
      <div
        className="filter-header"
        id={"filter-" + filterField}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setExpanded(expanded => !expanded);
        }}
      >
        <div className="filter-label">{ts(filterField)}:</div>
        <AnimatePresence>
          {!expanded && (
            <>
              {activeFilters[filterField] ? (
                <motion.div
                  className="filter-value filter-value-active"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20, transition: { damping: 1 } }}
                >
                  {activeFilters[filterField].map((af, idx) => {
                    charCount += Math.max(ts(filterField, af).length + 3, 5);
                    if (
                      moreCount === 0 &&
                      charCount > FILTER_VALUE_CHAR_SPACE &&
                      idx > 0
                    ) {
                      moreCount = activeFilters[filterField].length - idx;
                    }
                    return charCount <= FILTER_VALUE_CHAR_SPACE || idx === 0 ? (
                      <span key={af}>{ts(filterField, af)}</span>
                    ) : null;
                  })}
                  {moreCount > 0 && <span key={"more"}>+{moreCount}</span>}
                </motion.div>
              ) : (
                <motion.div
                  className="filter-value filter-value-inactive"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 0.4, y: 0 }}
                  exit={{ opacity: 0, y: 20, transition: { damping: 1 } }}
                >
                  {t("filter.any")}
                </motion.div>
              )}
            </>
          )}
        </AnimatePresence>
        <div
          title={expanded ? t("action.close") : t("action.expand")}
          className="toggle-icon"
        >
          <Icon name={expanded ? "chevron-up" : "chevron-down"} />
        </div>
      </div>
      <motion.div
        animate={{ height: expanded ? "auto" : 0 }}
        className={"filter-collapse"}
      >
        <motion.ul
          animate={{
            opacity: expanded ? 1 : 0
          }}
        >
          {Object.entries(data).map(([value, counts]) => (
            <ProductsFiltersItem
              key={value}
              field={filterField}
              value={value}
              unit={settings.specifications?.[filterField]?.unit || ""}
              description={settings.specifications?.[filterField]?.description}
              count={counts.filteredCount}
              totalCount={counts.total}
              activeFilters={activeFilters}
              setFilter={setFilter}
            />
          ))}
        </motion.ul>
      </motion.div>
    </div>
  );
};

export default ProductsFilter;
